<mat-form-field appearance="outline" [ngStyle]="style" class="w-full">
  <mat-label>{{ placeholder }}</mat-label>
  <input
    matInput
    [disabled]="disabled"
    [placeholder]="placeholder"
    [matAutocomplete]="auto"
    [name]="name"
    [(ngModel)]="parentVal"
    (ngModelChange)="onModif($event)"
    #matInput
    [required]="required"
    (keyup)="keyUp($event)"
    (keydown)="keyDown($event)"
    (blur)="keyblur()"
    matInputAutofocus
    (focus)="focusFunction()"
  />

  <button
    mat-button
    *ngIf="parentVal"
    matSuffix
    mat-icon-button
    aria-label="Clear"
    (click)="clearText()"
  >
    <mat-icon>close</mat-icon>
  </button>

  <mat-autocomplete
    (optionSelected)="onSelectionChanged($event)"
    autoActiveFirstOption
    #auto="matAutocomplete"
  >
    <mat-option *ngIf="!exist" class="is-loading">
      <mat-spinner diameter="50"></mat-spinner>
    </mat-option>
    <mat-option *ngIf="isAddNewLine" [disabled]="true" class="h-auto">
      <!-- dynamic-form.component.html -->
      <form
        [formGroup]="form"
        (ngSubmit)="onFormSubmit()"
        class="flex flex-wrap items-baseline w-full"
      >
        <div *ngFor="let column of columnsSchema">
          <mat-form-field
            *ngIf="column.type !== 'checkbox' && column.type !== 'select'"
          >
            <ng-container [ngSwitch]="column.type">
              <input
                *ngSwitchCase="'text'"
                matInput
                [formControlName]="column.key"
                [placeholder]="column.label"
              />
              <input
                *ngSwitchCase="'number'"
                matInput
                [formControlName]="column.key"
                [placeholder]="column.label"
                type="number"
              />
              <input
                *ngSwitchCase="'date'"
                matInput
                [formControlName]="column.key"
                [placeholder]="column.label"
                [matDatepicker]="picker"
              />
              <input
                *ngSwitchCase="'email'"
                matInput
                [formControlName]="column.key"
                [placeholder]="column.label"
                type="email"
              />
              <textarea
                *ngSwitchCase="'textarea'"
                matInput
                [formControlName]="column.key"
                [placeholder]="column.label"
                [matTextareaAutosize]="true"
                [matAutosizeMinRows]="3"
              ></textarea>
              <!-- You can add more cases for different types as needed -->
            </ng-container>
            <mat-datepicker-toggle
              matSuffix
              [for]="picker"
              *ngIf="column.type === 'date'"
            ></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>
          <mat-checkbox
            *ngIf="column.type === 'checkbox'"
            [formControlName]="column.key"
            [value]="'1'"
            >{{ column.label }}</mat-checkbox
          >

          <div *ngIf="column.type === 'select'">
            <mat-label>{{ column.label }}</mat-label>
            <select [formControlName]="column.key" #selector>
              <option
                *ngFor="let option of column.options"
                [value]="option.value"
              >
                {{ option.label }}
              </option>
            </select>
          </div>
        </div>
        <button mat-raised-button color="primary" type="submit">Ajouter</button>
      </form>
    </mat-option>
    <div *ngIf="exist">
      <mat-table #table [dataSource]="dataSource" matSort class="example-table">
        <div *ngFor="let item of tbrecherche">
          <ng-container [matColumnDef]="item.TableRD_Champs">
            <mat-header-cell *matHeaderCellDef mat-sort-header>
              {{ item.TableRD_Des }}
            </mat-header-cell>
            <mat-cell *matCellDef="let row">
              <div>{{ row[item.TableRD_Champs] }}</div>
            </mat-cell>
          </ng-container>
        </div>
        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-option
          *matRowDef="let row; columns: displayedColumns"
          id="{{ row[displayedColumns[numColonneToReturn]] }}"
          [value]="row[displayedColumns[numColonneToShow]]"
        >
          <mat-row></mat-row>
        </mat-option>
      </mat-table>
    </div>
  </mat-autocomplete>
</mat-form-field>
